<div
    class="edit-profile-layout-container tw-relative tw-overflow-y-auto tw-h-full"
    data-test="edit-profile-layout"
    [attr.aria-busy]="isLoadingProfile()"
>
    <div class="edit-profile-layout-content">
        <mon-page-layout
            [header]="'editProfile.header' | transloco"
            [showBackButton]="false"
            [formLayout]="'single-column'"
        >
            @if (!isLoadingProfile()) {
                <form #editForm="ngForm" (ngSubmit)="onSubmit(editForm)" class="edit-profile-form tw-flex tw-flex-col tw-gap-8" data-test="edit-profile-form">
                    <div>
                        <p-card [styleClass]="'op-form-card'" data-test="edit-profile-details-card">
                            <div class="tw-flex tw-flex-col tw-gap-6">
                                <h2 class="tw-text-xl tw-font-semibold tw-mt-0 tw-mb-0">
                                    {{ 'editProfile.details.header' | transloco }}
                                </h2>

                                <div class="tw-flex tw-flex-col tw-gap-4">
                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="email">
                                            {{ 'editProfile.details.email' | transloco }}
                                            <span aria-hidden="true">*</span>
                                        </label>
                                        <input
                                            pInputText
                                            id="email"
                                            name="email"
                                            type="email"
                                            [value]="profileData.email"
                                            [disabled]="true"
                                            class="w-full"
                                            [placeholder]="'editProfile.details.emailPlaceholder' | transloco"
                                            [attr.aria-label]="'editProfile.details.email' | transloco"
                                            data-test="edit-profile-email-input"
                                        />
                                    </div>

                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="organization">
                                            {{ 'editProfile.details.organization' | transloco }}
                                            <span aria-hidden="true">*</span>
                                        </label>
                                        <input
                                            pInputText
                                            id="organization"
                                            name="organization"
                                            type="text"
                                            [value]="organizationName"
                                            [disabled]="true"
                                            class="w-full"
                                            [placeholder]="'editProfile.details.organizationPlaceholder' | transloco"
                                            [attr.aria-label]="'editProfile.details.organization' | transloco"
                                            data-test="edit-profile-organization-input"
                                        />
                                    </div>

                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="first_name">
                                            {{ 'editProfile.details.firstName' | transloco }}
                                            <span aria-hidden="true">*</span>
                                        </label>
                                        <input
                                            pInputText
                                            id="first_name"
                                            name="first_name"
                                            type="text"
                                            [(ngModel)]="profileData.first_name"
                                            required
                                            class="w-full"
                                            [placeholder]="'editProfile.details.firstNamePlaceholder' | transloco"
                                            [attr.aria-label]="'editProfile.details.firstName' | transloco"
                                            [attr.aria-required]="true"
                                            data-test="edit-profile-first-name-input"
                                        />
                                    </div>

                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="last_name">
                                            {{ 'editProfile.details.lastName' | transloco }}
                                            <span aria-hidden="true">*</span>
                                        </label>
                                        <input
                                            pInputText
                                            id="last_name"
                                            name="last_name"
                                            type="text"
                                            [(ngModel)]="profileData.last_name"
                                            required
                                            class="w-full"
                                            [placeholder]="'editProfile.details.lastNamePlaceholder' | transloco"
                                            [attr.aria-label]="'editProfile.details.lastName' | transloco"
                                            [attr.aria-required]="true"
                                            data-test="edit-profile-last-name-input"
                                        />
                                    </div>

                                    <div class="tw-flex tw-flex-col tw-gap-2 edit-profile-locale-field">
                                        <label for="locale">
                                            {{ 'editProfile.details.language' | transloco }}
                                            <span aria-hidden="true">*</span>
                                        </label>
                                        <p-select
                                            inputId="locale"
                                            name="locale"
                                            [(ngModel)]="profileData.locale"
                                            [options]="languages"
                                            optionLabel="name"
                                            optionValue="value"
                                            required
                                            [placeholder]="'editProfile.details.languagePlaceholder' | transloco"
                                            styleClass="w-full"
                                            [attr.aria-label]="'editProfile.details.language' | transloco"
                                            data-test="edit-profile-locale-select"
                                        />
                                    </div>

                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="timezone">
                                            {{ 'editProfile.details.timezone' | transloco }}
                                            <span aria-hidden="true">*</span>
                                        </label>
                                        <p-select
                                            inputId="timezone"
                                            name="timezone"
                                            [(ngModel)]="profileData.timezone"
                                            [options]="timezones"
                                            optionLabel="name"
                                            optionValue="value"
                                            [filter]="true"
                                            required
                                            [placeholder]="'editProfile.details.timezonePlaceholder' | transloco"
                                            styleClass="w-full"
                                            [attr.aria-label]="'editProfile.details.timezone' | transloco"
                                            data-test="edit-profile-timezone-select"
                                        />
                                    </div>

                                    <div class="tw-flex tw-items-center tw-gap-3">
                                        <p-toggleSwitch
                                            name="email_notifications_exports"
                                            [(ngModel)]="profileData.email_notifications.exports"
                                            inputId="email_notifications_exports"
                                            [attr.aria-label]="'editProfile.details.notifyExport' | transloco"
                                            data-test="edit-profile-email-notifications-toggle"
                                        />
                                        <label for="email_notifications_exports">
                                            {{ 'editProfile.details.notifyExport' | transloco }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </p-card>
                    </div>

                    <div>
                        <p-card [styleClass]="'op-form-card'" data-test="edit-profile-security-card">
                            <div class="tw-flex tw-flex-col tw-gap-6">
                                <h2 class="tw-text-xl tw-font-semibold tw-mt-0 tw-mb-0">
                                    {{ 'editProfile.security.header' | transloco }}
                                </h2>

                                <div class="tw-flex tw-flex-col tw-gap-4">
                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="auth_user_password">
                                            {{ 'editProfile.security.currentPassword' | transloco }}
                                        </label>
                                        <input
                                            pInputText
                                            id="auth_user_password"
                                            name="auth_user_password"
                                            type="password"
                                            autocomplete="current-password"
                                            [(ngModel)]="profileData.auth_user_password"
                                            class="w-full"
                                            [placeholder]="'editProfile.security.currentPasswordPlaceholder' | transloco"
                                            [attr.aria-label]="'editProfile.security.currentPassword' | transloco"
                                            data-test="edit-profile-current-password-input"
                                        />
                                    </div>

                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="password">
                                            {{ 'editProfile.security.newPassword' | transloco }}
                                        </label>
                                        <input
                                            pInputText
                                            id="password"
                                            name="password"
                                            type="password"
                                            autocomplete="new-password"
                                            [(ngModel)]="profileData.password"
                                            class="w-full"
                                            [placeholder]="'editProfile.security.newPasswordPlaceholder' | transloco"
                                            [attr.aria-label]="'editProfile.security.newPassword' | transloco"
                                            data-test="edit-profile-new-password-input"
                                        />
                                    </div>

                                    <div class="tw-flex tw-flex-col tw-gap-2">
                                        <label for="password_confirmation">
                                            {{ 'editProfile.security.confirmPassword' | transloco }}
                                        </label>
                                        <input
                                            pInputText
                                            id="password_confirmation"
                                            name="password_confirmation"
                                            type="password"
                                            autocomplete="new-password"
                                            [(ngModel)]="profileData.password_confirmation"
                                            class="w-full"
                                            [placeholder]="'editProfile.security.confirmPasswordPlaceholder' | transloco"
                                            [attr.aria-label]="'editProfile.security.confirmPassword' | transloco"
                                            data-test="edit-profile-confirm-password-input"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <button
                                        pButton
                                        type="button"
                                        class="p-button-link tw-p-0 tw-text-left"
                                        (click)="setup2FA()"
                                        [attr.aria-label]="is2FAEnabled() ? ('editProfile.security.disable2fa' | transloco) : ('editProfile.security.enable2fa' | transloco)"
                                        data-test="edit-profile-2fa-action"
                                    >
                                        <span class="tw-underline">
                                            {{ is2FAEnabled() ? ('editProfile.security.disable2fa' | transloco) : ('editProfile.security.enable2fa' | transloco) }}
                                        </span>
                                        <!-- TODO: Replace inline SVG with reusable icons -->
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="material-symbol-svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240q17 0 28.5 11.5T480-800q0 17-11.5 28.5T440-760H200v560h560v-240q0-17 11.5-28.5T800-480q17 0 28.5 11.5T840-440v240q0 33-23.5 56.5T760-120H200Zm560-584L416-360q-11 11-28 11t-28-11q-11-11-11-28t11-28l344-344H600q-17 0-28.5-11.5T560-800q0-17 11.5-28.5T600-840h200q17 0 28.5 11.5T840-800v200q0 17-11.5 28.5T800-560q-17 0-28.5-11.5T760-600v-104Z"/></svg>
                                    </button>
                                </div>
                            </div>
                        </p-card>
                    </div>

                    @if (aiRemediationActive()) {
                        <div>
                            <p-card [styleClass]="'op-form-card'" data-test="edit-profile-remediation-card">
                                <div class="tw-flex tw-flex-col tw-gap-6">
                                    <h2 class="tw-flex tw-items-center tw-gap-3 tw-text-xl tw-font-semibold tw-mt-0 tw-mb-0">
                                        <span>{{ 'editProfile.remediation.header' | transloco }}</span>
                                        <span class="edit-profile-beta-pill">{{ 'editProfile.remediation.beta' | transloco }}</span>
                                    </h2>

                                    <p class="tw-m-0">
                                        {{ 'editProfile.remediation.description' | transloco }}
                                    </p>

                                    <div class="tw-flex tw-flex-col tw-gap-4">
                                        @for (role of remediationRoles; track role) {
                                            <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
                                                <label
                                                    class="tw-font-semibold"
                                                    [for]="'edit-profile-remediation-' + role"
                                                    [attr.data-test]="'edit-profile-remediation-role-label-' + role"
                                                >
                                                    {{ getResponsibilityTranslationKey(role) | transloco }}
                                                </label>
                                                <p-toggleSwitch
                                                    [name]="'edit-profile-remediation-' + role"
                                                    [inputId]="'edit-profile-remediation-' + role"
                                                    [ngModel]="isResponsibilitySelected(role)"
                                                    (ngModelChange)="onResponsibilityToggle(role, $event)"
                                                    [attr.aria-label]="getResponsibilityTranslationKey(role) | transloco"
                                                    [attr.data-test]="'edit-profile-remediation-role-toggle-' + role"
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    }

                    <div class="form-actions">
                        <button
                            pButton
                            type="button"
                            [label]="'editProfile.cancelBtn' | transloco"
                            severity="secondary"
                            variant="text"
                            class="edit-profile-cancel-button"
                            (click)="onCancel()"
                            (keydown.enter)="onCancel()"
                            data-test="edit-profile-cancel-button"
                        ></button>
                        <p-button
                            type="submit"
                            [label]="'editProfile.saveBtn' | transloco"
                            [loading]="isSubmitting()"
                            [disabled]="isSubmitting()"
                            data-test="edit-profile-save-button"
                        />
                    </div>
                </form>
            } @else {
                <div class="tw-flex tw-justify-center tw-py-6" data-test="edit-profile-loading-spinner-container">
                    <p-progress-spinner styleClass="p-progress-spinner-lg" strokeWidth="4" data-test="edit-profile-loading-spinner" />
                </div>
            }
        </mon-page-layout>
    </div>
</div>
